export default __webpack_public_path__ + "static/media/insurance-ad.93609fee.png";